import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useGameStore } from '../stores/gameStore';

/**
 * Per-game surface route guard (#619). A deep link to a surface route (e.g.
 * /questions) while the ACTIVE game's module doesn't declare the surface
 * redirects to the dashboard — mirroring the server's requireGameSurface
 * 404 on the same paths. Until the games list loads, children render (the
 * incumbent must not flicker; the server still 404s a truly bad request).
 */
export default function RequireSurface({
  surface,
  children,
}: {
  surface: string;
  children: ReactNode;
}) {
  const games = useGameStore((s) => s.games);
  const gamesLoaded = useGameStore((s) => s.gamesLoaded);
  const activeGameId = useGameStore((s) => s.activeGameId);
  const activeGame = games.find((g) => g.gameId === activeGameId);
  if (gamesLoaded && !(activeGame?.surfaces?.includes(surface) ?? false)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
